<style scoped>
    .file-uploader{
        position: relative;
    }
    .file-uploader /deep/ img{
        max-width: 100%;
    }
    .ivu-spin{
        background-color: hsla(0,0%,100%,.6);
    }
</style>
<template>
  <div class="file-uploader">
    <Upload
    
      ref="uploader"
      :disabled="disabled"
      with-credentials
      :type="type"
      border
      :paste="true"
      :multiple="multiple"
      :max-size="max_size"
      :format="format"
      :data="data"
      :on-format-error="formatError"
      :on-exceeded-size="exceededSize"
      :before-upload="beforeUpload"
    
      :on-success="uploadFileOk"
      :on-error="uploadFileFail"
      :action="upload_path"
    >
      <!--   :on-progress="uploadFileProgress" -->
      <slot>
        <div style="padding: 20px 0">
          <Icon
            type="ios-cloud-upload"
            size="52"
            style="color: #3399ff"
          />
          <p>点击或拖拽文件到此处上传</p>
        </div>
      </slot>
      <!--<Button size="small" icon="ios-cloud-upload-outline">
                <slot>上传附件</slot>
            </Button>-->
    </Upload>
    <Spin
      v-show="uploading"
      fix
    />
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    props: {
      multiple: {
        type: Boolean,
        default: true
      },
      upload_path: {
        type: String,
        'default': Util.api.attachment_upload_path
      },
      format: {
        type: Array,
        'default': () => {
          return [];
        }
      },
      data: {
        type: Object,
        default: () => {
          return {};
        }
      },
      max_size: {
        type: Number,
        //50mb
        'default': 1024 * 50
      },
      valid: {
        type: Function
      },
      // select or drag
      type: {
        type: String,
        default: 'drag',
      },
      validateFile: {
        type: Function
      },
      disabled: {
        type: Boolean
      }
    },
    data() {
      return {
        file: null,
        new_file: {
          bfile_id: 0,
          name: '',
          desc: '',
          is_dir: false
        },
        loading: false,
        uploading: false,
        share_customers: [],
        search_customer_text: '',
        search_customer_results: []
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      clearList() {
        // hack 直接更新列表
        this.$refs.uploader.fileList = this.$refs.uploader.fileList.filter(i => i.status !== 'finished')
        // console.log(this.$refs.uploader)
        // this.$refs.uploader.fileList
        // const arr = this.$refs.uploader.fileList || []
        // const go = arr.map(i => i.status).every(key => key === 'finished')
        // if (go) {
        //   setTimeout(() => {
        //     this.$refs.uploader.clearFiles();
        //   }, 200)
        // }
      },
      beforeUpload(file) {
        if (file.name.indexOf('%') > -1) {
          this.$Modal.error({
            title: '提示',
            content: '文件名不能包含百分号%'
          });
          return false;
        }
        this.$emit('start');
        if (this.valid) {
          return this.valid();
        }
        if (this.validateFile) {
          return this.validateFile(file);
        }
        return true;
      },
      uploadFileProgress(ev, file, fileList) {
        this.uploading = true;
        console.log(ev);
      },
      uploadFileOk(res, file, fileList) {
        this.uploading = false;
        
        if (res.code === 1) {
          this.$emit('done', res);
          this.$emit('uploaded', res.file);
        } else {
          this.$emit('fail', {message: res.msg});
          this.$Modal.error({title: '提示', content: res.msg});
        }
        this.clearList()
        this.$emit('finally');
      },
      uploadFileFail(error, file, fileList) {
      
        this.uploading = false;
        this.clearList()
        const msg = `<p>${error.message}</p>`;
        /* msg += `<p>如果 macOS 系统频繁上传失败, 可尝试关闭支付宝插件.</p>`;
                msg += `<p>步骤如下:</p>`;
                msg += `<p> 1. 打开终端命令行程序</p>`;
                msg += `<p> 2. 输入: sudo launchctl remove com.alipay.DispatcherService</p>`;
                msg += `<p> 3. 如果提示输入密码, 请输入电脑开机密码.</p>`; */
        this.$emit('fail', error);
        this.$Modal.error({
          title: '上传失败',
          content: msg
        });
        this.$emit('finally');
      },
      handleUpload(file) {
        this.file = file;
        return false;
      },
      formatError(file, fileList) {
        this.$Modal.error({
          title: '提示',
          content: `上传文件格式错误(支持:${this.format})`
        });
      },
      exceededSize(file, fileList) {
        let content = '文件大小超出限制';
        content += this.max_size > 1024 ? `(最大${Util.formatDecimal(this.max_size / 1024)}mb)` : `(最大${Util.formatDecimal(this.max_size)}kb)`;
        this.$Modal.error({
          title: '提示',
          content: content
        });
      },
      getFileSize(file) {
        const size = file.size || 0;
        const biggerThanMB = math.eval(`${size} / 1024 / 1024 > 1`);
        if (biggerThanMB) {
          return math.eval(`${size} / 1024 / 1024`).toFixed(1) + 'mb';
        } else {
          return math.eval(`${size} / 1024`).toFixed(1) + 'kb';
        }
      }
    }
  }
</script>
